import { useNavigate } from 'react-router';
import { IconButton } from '../../Common';
import { ProjectAssigneesWithUserInfoDto } from '../../../commonTypes/project.types';
import { getCurrencySymbol } from '../../../util/general';

interface MemberCardProps {
    member: ProjectAssigneesWithUserInfoDto;
    showRates: boolean;
    canEdit: boolean;
    onEdit?: (member: ProjectAssigneesWithUserInfoDto) => void;
    currency: string;
}

export const MemberCard = ({ member, showRates, canEdit, onEdit, currency }: MemberCardProps) => {
    const navigate = useNavigate();
    const fullName = `${member.givenName || ''} ${member.familyName || ''}`.trim();
    const jobTitle = member.title || 'No title set';

    const displayCurrency = member.currencyCode || currency;
    const fmtRate = (rate?: number) => (rate == null ? 'Not set' : `${getCurrencySymbol(displayCurrency)}${rate.toFixed(2)}`);
    const fmtType = (x?: string) => (!x ? 'Not set' : x.charAt(0).toUpperCase() + x.slice(1).toLowerCase());
    const fmtRole = (str?: string) => (!str ? 'Not set' : str.toLowerCase().charAt(0).toUpperCase() + str.toLowerCase().slice(1));

    const handleCardClick = () => {
        navigate(`/profile/${member.userSub}`);
    };

    return (
        <div className="member-card">
            <div className="member-card__header member-card__header--clickable" onClick={handleCardClick}>
                <img
                    className="member-card__avatar"
                    src={member.imageUrl || '/svg/person.svg'}
                    alt={fullName}
                    onError={e => ((e.target as HTMLImageElement).src = '/svg/person.svg')}
                />
                <div className="member-card__info">
                    <h4 className="paragraph-3 member-card__name">{fullName}</h4>
                    <p className="paragraph-5 member-card__role">{jobTitle}</p>
                </div>
                {canEdit && (
                    <IconButton
                        onClick={e => {
                            e.stopPropagation();
                            onEdit?.(member);
                        }}
                        iconUrl="/svg/pen-grey.svg"
                        iconAlt="edit"
                        variant="icon"
                        className="member-card__edit"
                    />
                )}
            </div>

            {showRates && (
                <div className="member-card__details">
                    <p className="paragraph-5 member-card__label">Rate</p>
                    <span className="paragraph-5 member-card__separator">/</span>
                    <p className="paragraph-5 member-card__value">{member.billable ? fmtRate(member.rate) : 'Non-billable'}</p>

                    {member.billable && (
                        <>
                            <p className="paragraph-5 member-card__label">Type</p>
                            <span className="paragraph-5 member-card__separator">/</span>
                            <p className="paragraph-5 member-card__value">{fmtType(member.rateType)}</p>

                            <p className="paragraph-5 member-card__label">Currency</p>
                            <span className="paragraph-5 member-card__separator">/</span>
                            <p className="paragraph-5 member-card__value">{displayCurrency}</p>
                        </>
                    )}
                    <p className="paragraph-5 member-card__label">Role</p>
                    <span className="paragraph-5 member-card__separator">/</span>
                    <p className="paragraph-5 member-card__value">{fmtRole(member.assignedRoles[0].projectRoleDto.name)}</p>
                </div>
            )}
        </div>
    );
};
